import { render, staticRenderFns } from "./ed-full-screen.vue?vue&type=template&id=05ab42de&scoped=true&"
import script from "./ed-full-screen.ts?vue&type=script&lang=ts&"
export * from "./ed-full-screen.ts?vue&type=script&lang=ts&"
import style0 from "./ed-full-screen.scss?vue&type=style&index=0&id=05ab42de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab42de",
  null
  
)

export default component.exports